export default {
  TITLE: `Sommaire des requêtes de {{name}}`,
  SUMMARY: ``,
  TIMEOFFSREQUESTS: `Congés:`,
  ATTENDANCEREQUESTS: `Absences:`,
  SHIFTS: `Quarts de travail:`,
  REQUESTSBYTYPE: `{{count}} requête de type {{typeName}}.`,
  REQUESTSBYTYPE_other: `{{count}} requêtes de type {{typeName}}.`,
  SHIFTSASSIGNEDTO: `Assiggné à {{count}} quart de travail.`,
  SHIFTSASSIGNEDTO_other: `Assigné à {{count}} quarts de travail.`,
  NOSHIFTSASSIGNEDTO: `L'employé n'a été assigné à aucun quart de travail pour ces dates.`,
  NOREQUESTS: `Il n'y a aucun requête demandée pour ces dates.`
}
